import en from './translations/en.json'
// import hn from './translations/hn.json'
import fr from './translations/fr.json'

export default {
    en, fr
}


// WEBPACK FOOTER //
// ./src/lang/index.js